import { render, staticRenderFns } from "./EditBlockNavigationTabLayout.vue?vue&type=template&id=e82bc566&scoped=true&"
import script from "./EditBlockNavigationTabLayout.vue?vue&type=script&lang=js&"
export * from "./EditBlockNavigationTabLayout.vue?vue&type=script&lang=js&"
import style0 from "./EditBlockNavigationTabLayout.vue?vue&type=style&index=0&id=e82bc566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82bc566",
  null
  
)

export default component.exports